import { OnbPageURLs, RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

export const getTypeAndPage = (url: string) => {
  if (url.includes(OnbPageURLs.BPReconfirmation)) {
    return {
      requestType: RequestTypes.BPReconfirmation,
      page: OnbPageURLs.BPReconfirmation,
    }
  }
  if (
    url.includes(OnbPageURLs.BPRegistration) &&
    !url.includes(OnbPageURLs.BPRegistrationRequests)
  ) {
    return {
      requestType: RequestTypes.BPRegistration,
      page: OnbPageURLs.BPRegistration,
    }
  }
  if (url.includes(OnbPageURLs.SimplePartnerRegistration)) {
    return {
      requestType: RequestTypes.SimplePartnerRegistration,
      page: OnbPageURLs.SimplePartnerRegistration,
    }
  }
  return null
}
